module.exports = __webpack_public_path__ + "img/two.806be208.png";